import { createAction, props } from '@ngrx/store';
import {PoolScope} from "../pool/pool.models";
import SportEvent = PoolScope.SportEvent;

export const callSportEvents = createAction('sportEvents',
  props<{
    id: any,
  }>());

export const successSportEvent = createAction('sportEvents.success',
  props<{
    sport_event: SportEvent
  }>());

export const failSportEvent = createAction('sportEvents.fail',
  props<{
    error: any
  }>());

export const partialSpUpdate = createAction('[SportEvents] Partial update / pool sport events',
  props<{
    data: any, // can have model for different websocket event's data
    event?: string
  }>());
